<template>
  <section class="page-container">
    <el-col :span="24" class="toolbar">
      <el-form :inline="true" :model="filters">
        <el-form-item>
          <el-button type="primary" @click="handleAdd">新增</el-button>
        </el-form-item>
      </el-form>
    </el-col>

    <el-table
      v-loading="listLoading"
      :data="results"
      highlight-current-row
      border
      style="width: 100%"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column prop="id" label="编号"></el-table-column>
      <el-table-column prop="title" label="标题"></el-table-column>
      <el-table-column prop="content" label="意见内容"></el-table-column>
      <el-table-column prop="imageList" label="示例图片">
        <template slot-scope="scope">
          <img
            v-for="(img, i) in scope.row.imageList"
            :key="i"
            :src="img.url"
            style="max-height: 100px; max-width: 100px"
          />
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间">
        <template slot-scope="scope">{{ scope.row.createTime | formatDate }}</template>
      </el-table-column>
      <el-table-column label="操作" width="150">
        <template slot-scope="scope">
          <el-button size="small" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <my-pagination
      :page="page"
      @current-change="handlePageChange"
      @size-change="handleLimitChange"
    />

    <el-dialog
      title="新增"
      :visible.sync="addFormVisible"
      :close-on-click-modal="false"
      width="80%"
    >
      <el-form ref="addForm" :model="addForm" label-width="80px">
        <el-form-item label="标题">
          <el-input v-model="addForm.title"></el-input>
        </el-form-item>

        <el-form-item label="意见内容">
          <el-input v-model="addForm.content" type="textarea" rows="4"></el-input>
        </el-form-item>

        <el-form-item label="示例图片">
          <batch-image-upload v-model="addForm.imageList" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button type="primary" :loading="addLoading" @click.native="addSubmit">提交</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="编辑"
      :visible.sync="editFormVisible"
      :close-on-click-modal="false"
      width="80%"
    >
      <el-form ref="editForm" :model="editForm" label-width="80px">
        <el-input v-model="editForm.id" type="hidden"></el-input>

        <el-form-item label="标题">
          <el-input v-model="editForm.title"></el-input>
        </el-form-item>

        <el-form-item label="意见内容">
          <el-input v-model="editForm.content" type="textarea" rows="4"></el-input>
        </el-form-item>

        <el-form-item label="示例图片">
          <batch-image-upload v-model="editForm.imageList" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button type="primary" :loading="editLoading" @click.native="editSubmit">提交</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import MyPagination from "@/components/MyPagination";
import BatchImageUpload from "@/components/BatchImageUpload";
export default {
  name: "LegitCheckOpinion",
  components: { MyPagination, BatchImageUpload },
  data() {
    return {
      results: [],
      listLoading: false,
      page: {},
      filters: {},
      selectedRows: [],

      addForm: {},
      addFormVisible: false,
      addLoading: false,

      editForm: {},
      editFormVisible: false,
      editLoading: false,
    };
  },
  mounted() {
    this.list();
  },
  methods: {
    async list() {
      const params = Object.assign(this.filters, {
        page: this.page.page,
        limit: this.page.limit,
      });
      try {
        const data = await this.axios.form("base:/api/admin/legit-check-opinion/list", params);
        this.results = data.results;
        this.page = data.page;
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      } finally {
        this.listLoading = false;
      }
    },
    async handlePageChange(val) {
      this.page.page = val;
      await this.list();
    },
    async handleLimitChange(val) {
      this.page.limit = val;
      await this.list();
    },
    handleAdd() {
      this.addForm = {};
      this.addFormVisible = true;
    },
    async addSubmit() {
      if (!this.addForm.title) {
        this.$notify.error({ title: "错误", message: "请填写标题" });
        return;
      }
      if (!this.addForm.content) {
        this.$notify.error({ title: "错误", message: "请填写意见内容" });
        return;
      }
      try {
        await this.axios.form("base:/api/admin/legit-check-opinion/create", {
          title: this.addForm.title,
          content: this.addForm.content,
          imageList: JSON.stringify(this.addForm.imageList || []),
        });
        this.$message({ message: "提交成功", type: "success" });
        this.addFormVisible = false;
        await this.list();
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      }
    },
    async handleEdit(index, row) {
      try {
        const data = await this.axios.get("base:/api/admin/legit-check-opinion/" + row.id);
        this.editForm = Object.assign({}, data);
        this.editFormVisible = true;
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      }
    },
    async editSubmit() {
      if (!this.editForm.title) {
        this.$notify.error({ title: "错误", message: "请填写标题" });
        return;
      }
      if (!this.editForm.content) {
        this.$notify.error({ title: "错误", message: "请填写意见内容" });
        return;
      }
      try {
        await this.axios.form("base:/api/admin/legit-check-opinion/update", {
          id: this.editForm.id,
          title: this.editForm.title,
          content: this.editForm.content,
          imageList: JSON.stringify(this.editForm.imageList || []),
        });
        await this.list();
        this.editFormVisible = false;
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      }
    },

    handleSelectionChange(val) {
      this.selectedRows = val;
    },
  },
};
</script>

<style lang="scss" scoped></style>
